import React from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Button, Modal, Switch, Icon } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import TimePicker from 'rc-time-picker';
import FadeLoader from 'react-spinners/FadeLoader';
import { updateSettingsList } from 'middleware/settings/actions';
import { settingDialog as settingDialogStrings } from 'ui/constants/strings';
import { parseTimeToObject, prepareTimeForAPI, timeFormat } from 'modules/setting';
import FamilyList from 'ui/components/familyList';
import { toast } from 'react-toastify';
import { Checkbox } from 'antd';
import 'rc-time-picker/assets/index.css';

const styles = {
  settingDialog: {
    borderRadius: 0,
  },
}

class SettingDialog extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      alertOn: true,
      alertStart: '00:00:00',
      alertEnd: '00:00:00',
      alertFamilyIds: [],
      allFamilies: [],
      indeterminate: false,
      checkAll: false,
    }
  }
  

  componentDidUpdate(prevProps) {
    if(prevProps.isLoading === true && this.props.isLoading === false) {
      this.updateStateFromProps();
    }
  }

  updateStateFromProps = () => {
    const { alertFamilyIds, alertStart, alertEnd, alertOn, allFamilies } = this.props;
    const indeterminate = alertFamilyIds.length !== allFamilies.length && alertFamilyIds.length > 0;
    const checkAll = alertFamilyIds.length === allFamilies.length;
    this.setState({
      alertOn,
      alertStart,
      alertEnd,
      alertFamilyIds,
      allFamilies,
      indeterminate,
      checkAll,
    })
  }

  onSaveSetting = () => {
    const { updateSettingsList } = this.props;
    const { alertFamilyIds, alertStart, alertEnd, alertOn } = this.state;
    const newSetting = {
      alertOn,
      alertStart: prepareTimeForAPI(alertStart),
      alertEnd: prepareTimeForAPI(alertEnd),
      alertFamilyIds,
    }
    updateSettingsList(newSetting);
    toast.success("Success Saved Settings", {
      position: toast.POSITION.BOTTOM_CENTER
    });
    this.onCloseSettingDialog();
  }

  onCloseSettingDialog = () => {
    const { onCancel } = this.props;
    onCancel();
  }
  
  onChange = (value, key) => {
    this.setState({
      [key]: value.format(timeFormat),
    });
  }

  onToggleFamilyStatus = (id, status) => {
    const { alertFamilyIds, allFamilies } = this.state;
    if (status) {
      const indeterminate = alertFamilyIds.length !== allFamilies.length - 1;
      const checkAll = alertFamilyIds.length === allFamilies.length - 1;
      this.setState({
        alertFamilyIds: _.concat(alertFamilyIds, id),
        indeterminate,
        checkAll,
      })
    } else {
      const indeterminate = alertFamilyIds.length > 1;
      this.setState({
        alertFamilyIds: _.filter(alertFamilyIds, item => item !== id),
        indeterminate,
        checkAll: false,
      })
    }
  }

  onCheckAllChange = (e) => {
    const { allFamilies } = this.state;
    if (e.target.checked) {
      const alertFamilyIds = allFamilies.map(item => item.id);
      this.setState({
        alertFamilyIds,
        indeterminate: false,
        checkAll: e.target.checked,
      });
    } else {
      this.setState({
        alertFamilyIds: [],
        indeterminate: false,
        checkAll: e.target.checked,
      });
    }
  }
  
  renderToggleAlert = () => {
    const { alertOn } = this.state;
  
    return (
      <div className='toggleAlertContainer'>
        <span className='alertText'>
          { settingDialogStrings.alertToggleTitle }
        </span>
        <span className='alertSwitch'>
          <Switch
            checkedChildren={<Icon type="check" />}
            unCheckedChildren={<Icon type="close" />}
            checked={alertOn}
            onChange={(value) => {
              this.setState({ alertOn: value });
            }}
          />
        </span>
      </div>
    )
  }

  renderTimePickers = () => {
    const { alertStart, alertEnd } = this.state;
    return (
      <div className='settingDialogTimePickerContainer'>
        <div className='header'>
          { settingDialogStrings.alertTimeTitle }
        </div>
        <div className='title'>
          <span>
            { settingDialogStrings.alertStart }
          </span>
          <span>
            { settingDialogStrings.alertEnd }
          </span>
        </div>
        <div className='timePickerContainer'>
          <TimePicker
            showSecond={false}
            value={moment(parseTimeToObject(alertStart))}
            className='alertStart timePicker'
            onChange={(value) => this.onChange(value, 'alertStart')}
            format={timeFormat}
            allowEmpty={false}
            minuteStep={5}
            inputReadOnly
          />
          <TimePicker
            showSecond={false}
            value={moment(parseTimeToObject(alertEnd))}
            className='alertEnd timePicker'
            onChange={(value) => this.onChange(value, 'alertEnd')}
            format={timeFormat}
            allowEmpty={false}
            minuteStep={5}
            inputReadOnly
          />
        </div>
      </div>
    )
  }

  renderRoomListHeader = () => {
    const { checkAll, indeterminate } = this.state;
    return (
      <div className='settingDialogFamilyListHeader'>
        <span className='title'>
          { settingDialogStrings.familyListTitle }
        </span>
        <span className='checkBox'>
          <Checkbox
            indeterminate={indeterminate}
            onChange={this.onCheckAllChange}
            checked={checkAll}
          >
          </Checkbox>
        </span>
      </div>
    )
  }

  renderRoomList = () => {
    const { isLoading } = this.props;
    const { alertFamilyIds, allFamilies } = this.state;
    return (
      <div className='settingDialogFamilyListContainer'>
        {!isLoading && 
          <FamilyList 
            alertFamilyIds={alertFamilyIds}
            allFamilies={allFamilies}
            onToggleFamilyStatus={this.onToggleFamilyStatus}
          />
        }
        <FadeLoader loading={isLoading} />
      </div>
    )
  }

  render() {
    const { visible } = this.props;

    const title = (
      <div className='dialogTitle'>
      { settingDialogStrings.title }
      </div>
    )
    const foorter = (
      <div className='dialogFooter'>
        <Button className='footerSaveButtin' onClick={this.onSaveSetting}>
          { settingDialogStrings.confirmButton }
        </Button>
        <Button className='footerCancelButton' onClick={this.onCloseSettingDialog}>
          { settingDialogStrings.cancelButton }
        </Button>
      </div>
    )

    return (
      <Modal
        style={styles.settingDialog}
        centered
        visible={visible}
        maskClosable={false}
        title={title}
        destroyOnClose={true}
        footer={foorter}
        onCancel={() => this.onCloseSettingDialog()}
        wrapClassName={'dialog-setting'}
      >
        { this.renderToggleAlert() }
        { this.renderTimePickers() }
        { this.renderRoomListHeader() }
        { this.renderRoomList() }
      </Modal>
    );
  }
}

SettingDialog.defaultProps = {
};

SettingDialog.propTypes = {
  roomObject: PropTypes.object,
};

const mapStateToProps = (state) => {
  const { settingReducer } = state;
  return {
    ...settingReducer,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateSettingsList,
    },
    dispatch,
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(SettingDialog);
